import React, { useEffect, useMemo } from 'react';
import { Row, Card } from 'react-bootstrap';
import Filters from './Filters';
import { useDispatch, useSelector } from 'react-redux';
import { fetchAllTiles } from 'slices/glassDashboard/fetchAllTiles';
import GlassDataModal from './modal/GlassDataModal';
import { WIDGET_CONFIG } from './WidgetConfig';

const GlassDashboard = () => {
    const dispatch = useDispatch();
    const { start, end, requestId, supplier } = useSelector(s => s.glassSearchFilter);
    const widgets = useMemo(() => WIDGET_CONFIG.filter(x => x.allowedSuppliers.includes(+supplier)), [supplier]);

    useEffect(() => {
        const promise = dispatch(fetchAllTiles(widgets, { start, end, supplier }));

        return () => {
            promise.abort();
        };
    }, [requestId]);

    return (
        <>
            <Row className='g-3 mb-3'>
                <Card className='border-0 shadow-sm border-1' style={{ minHeight: '150px' }}>
                    <Filters />
                </Card>
            </Row>
            <Row className='g-3 mb-3'>
                {widgets.map(x => {
                    const Widget = x.component;
                    return <Widget key={x.id} />;
                })}
            </Row>
            <GlassDataModal />
        </>
    );
}

export default GlassDashboard;